import React from 'react';
import { FadeIn } from './Shared';
import { XCircle } from 'lucide-react';
export const PainSection = () => {
  const pains = ['Tu perro llora o ladra cuando te vas y no sabés cómo frenarlo sin que todo el edificio lo sepa', 'Cediste, volviste a casa cuando lloraba y ahora ladra más fuerte y más rápido cada vez', 'Probaste el spray, el collar, dejarlo la tele prendida, cansarlo antes de salir. Nada duró más de una semana', 'Cada mañana salís pensando "hoy va a ser igual que ayer"', 'Te da vergüenza hasta ir al gym por miedo a lo que dice el encargado cuando volvés', 'El domingo a la noche ya sentís la angustia de la semana que viene'];
  return <section className="py-16 md:py-24 px-4 bg-navy-950 relative overflow-hidden pt-[32px] pb-[32px]" data-id="element-218">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_100%,rgba(239,68,68,0.05),transparent_70%)] pointer-events-none" data-id="element-219"></div>
      <div className="max-w-3xl mx-auto relative z-10" data-id="element-220">
        <FadeIn data-id="element-221">
          <h2 className="text-3xl md:text-5xl text-white mb-10 text-center leading-tight font-[900] font-[Montserrat,_sans-serif]" data-id="element-222">
            ¿Cuántos audios de WhatsApp del vecino{' '}
            <br className="hidden md:block" data-id="element-223" />
            <span className="text-orange-400" data-id="element-224">
              más vas a recibir sin tener un sistema?
            </span>
          </h2>

          <div className="mx-auto mb-12 text-gray-200 text-center space-y-6 text-base md:text-lg font-sans opacity-90" data-id="element-225">
            <p data-id="element-226">
              Sos una persona que ama a su perro con todo. Lo adoptaste, lo
              cuidás, te preocupás por él genuinamente. Pero nadie te dijo que
              vivirías con esta presión constante.
            </p>
            <p data-id="element-227">
              El edificio se queja. El encargado te para en el ascensor. Y vos
              salís al trabajo todos los días con la culpa royéndote por dentro.
            </p>
          </div>

          <div className="flex justify-center mb-12" data-id="element-228">
            <div className="bg-gradient-to-r from-red-500/10 via-red-500/20 to-red-500/10 border-y border-red-500/30 py-6 px-8 w-full max-w-2xl text-center" data-id="element-229">
              <p className="font-bold text-white uppercase tracking-[0.15em] text-lg md:text-2xl font-sans" data-id="element-230">
                No es que tu perro sea un problema.
                <br className="md:hidden" data-id="element-231" />{' '}
                <span className="text-red-400" data-id="element-232">
                  Es que nadie te dio las herramientas correctas.
                </span>
              </p>
            </div>
          </div>

          <div className="bg-navy-900/60 border border-white/10 rounded-3xl p-6 md:p-10 mb-12" data-id="element-233">
            <ul className="space-y-5" data-id="element-234">
              {pains.map((pain, index) => <li key={index} className="flex items-start" data-id="element-235">
                  <XCircle className="w-5 h-5 md:w-6 md:h-6 text-red-500 mr-4 flex-shrink-0 mt-0.5" data-id="element-236" />
                  <span className="text-base md:text-lg text-white/90 font-sans leading-relaxed" data-id="element-237">
                    {pain}
                  </span>
                </li>)}
            </ul>
          </div>

          <div className="text-center" data-id="element-238">
            <h3 className="text-2xl md:text-4xl text-orange-400 leading-tight font-[900] font-[Montserrat,_sans-serif]" data-id="element-239">
              ¿Y si la próxima vez que cerrás la puerta, del otro lado hubiera
              silencio?
            </h3>
          </div>
        </FadeIn>
      </div>
    </section>;
};